import { Skeleton } from 'design-system';

const FEED_SKELETON_ROWS = 4;

export const FeedSkeleton = () => (
  <output
    aria-label='Loading feed updates'
    className='space-y-3'
  >
    {Array.from({ length: FEED_SKELETON_ROWS }, (_, index) => (
      <Skeleton
        key={index}
        aria-label='Loading feed card'
        className='h-28 w-full'
      />
    ))}
  </output>
);
